<template>
    <main-layout>
        <app-header icon="bottle">
            Régularisation
        </app-header>

        <action-bar :back="{name:'bouteille', params: {id: bouteille.id}}">
        </action-bar>

        <form class="wrap" @submit.prevent="sendForm">
            <h1>QUANTITÉ ACTUELLE : {{ bouteille.poids_net }} / {{ bouteille.poids_max }} Kg</h1>
            <label>Type de régularisation *</label>
            <div class="row">
                <div class="radio">
                    <input id="type-ajout" type="radio" name="type" value="6" v-model.number="op.type">
                    <label class="custom-radio" for="type-ajout">
                        Ajout
                        <i class="icon-valid"></i>
                    </label>
                </div>
                <div class="radio">
                    <input id="type-retrait" type="radio" name="type" value="7" v-model.number="op.type">
                    <label class="custom-radio" for="type-retrait">
                        Retrait
                        <i class="icon-valid"></i>
                    </label>
                </div>
            </div>
            <div>
                <label for="quantity">
                    Quantité corrigée *
                </label>
                <input type="number" step="0.001" min="0" id="quantity" v-model.number="op.quantity">
            </div>
            <div>
                <label for="comment">Commentaire *</label>
                <textarea name="comment" id="comment" v-model="op.comment" maxlength="500"></textarea>
            </div>
            <input type="submit" value="Valider">
        </form>
    </main-layout>
</template>

<script>
    import Bouteille from '../../js/models/Bouteille'
    import OperationBouteille from "../../js/models/OperationBouteille";
    import Offline from '../../js/models/Offline';

    export default {
        data() {
            return {
                op: {
                    type: null,
                    quantity: null,
                    comment: null
                },
                bouteille: {}
            }
        },

        methods: {
            sendForm() {
                if (this.op.type && this.op.quantity && this.op.comment) {
                    if (this.op.type === 6) {
                        if (this.bouteille.poids_net + this.op.quantity > this.bouteille.poids_max) {
                            swal('Quantité incohérente', `(${this.bouteille.poids_net}/${this.bouteille.poids_max} Kg)`, 'error');
                        } else {
                            this.newOperation();
                        }
                    } else if (this.op.type === 7) {
                        if (this.bouteille.poids_net - this.op.quantity < 0) {
                            swal('Quantité incohérente', `(${this.bouteille.poids_net}/${this.bouteille.poids_max} Kg)`, 'error');
                        } else {
                            this.newOperation();
                        }
                    }
                } else {
                    swal('Formulaire incomplet', "Veuillez compléter le formulaire", 'error');
                }
            },

            async newOperation() {
                let opObj = new OperationBouteille();
                const profil = JSON.parse(await localforage.getItem('profil'));

                let op = {
                    id: 'N-' + +new Date(),
                    id_fibsdd: null,
                    id_bouteille: this.bouteille.id,
                    type: this.op.type === 6 ? 'Régularisation "ajout"' : 'Régularisation "retrait"',
                    id_type: parseInt(this.op.type),
                    quantite: round(this.op.quantity, 3),
                    id_fluide: this.bouteille.fluide.id,
                    date: moment().format('YYYY-MM-DD'),
                    user: profil.first_name.charAt(0).toUpperCase() + '. ' + profil.last_name.toUpperCase(),
                    commentaire: this.op.comment,
                    createdAt: moment().format('YYYY-MM-DD HH:mm:ss')
                };

                let ops = await opObj.getList();
                ops.push(op);

                await localforage.setItem('listOperations', JSON.stringify(ops));
                await Offline.saveAction({
                    action: 'add',
                    type: 'OperationBouteille',
                    id: op.id
                });
                await Bouteille.applyOperation(op);

                this.$router.push({name: "bouteille", params: {id: this.bouteille.id}});
                return true;
            },

            fetchBottle() {
                return new Promise((resolve, reject) => {
                    let idBout = this.$route.params.id;

                    Bouteille.getBouteille(idBout).then(data => {
                            this.bouteille = data;
                            resolve(data)
                        })
                        .catch(err => reject(err))
                })
            }
        },

        mounted: function(){
            this.fetchBottle();
        },

        computed: {}
    }
</script>

<style lang="less" scoped>
    h1 {
        margin-bottom: 20px;
        padding-top: 15px;
        font-weight: 700;
    }

    .row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        .radio {
            width: 49%;

            input {
                display: none;

                &:checked + label {
                    background-color: #5698d2;
                    color: #ffffff;
                }
            }

            label {
                display: flex;
                height: 50px;
                text-align: center;
                justify-content: space-around;
                align-items: center;
                color: #999;
                background-color: #e2e2e2;
                border-radius: 5px;
                transition: 0.3s ease all;

                i {
                    font-size: 2.3rem;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// BouteilleRegul.vue?7616af1f